import React from 'react'

export default function NoteListEmpty() {
  return (
    <section className="notes-list-empty">
      <p className="notes-list__empty">No notes here.</p>
    </section>
  )
}
